import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import CarouselImageOne from "assets/images/teleconsult-on-demand-1.png";
import CarouselImageTwo from "assets/images/teleconsult-on-demand-2.png";
import CarouselImageThree from "assets/images/teleconsult-on-demand-3.png";
import CarouselImageFour from "assets/images/teleconsult-on-demand-4.png";

import "./TeleconsultOnDemand.scss";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";

function OnboardingModal() {
  const [show, setShow] = useState(true);
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleClose = () => {
    localStorage.setItem("teleconsult:ondemand-onboarded", true);
    setShow(false);
  };

  const data = [
    {
      image: CarouselImageOne,
      caption: "Introducing Doctor On-Demand",
      description:
        "You can now provide immediate consultations by accepting on-demand requests from patients, enhancing your healthcare experience",
    },
    {
      image: CarouselImageTwo,
      caption: "Enable On-Demand Mode",
      description:
        "Simply tap the switch in the top-right corner to turn on 'Doctor On Demand' to start getting instant consultation requests",
    },
    {
      image: CarouselImageThree,
      caption: "Review and Accept Requests",
      description:
        "Got a patient request? Quickly review their health issue and accept with a simple tap. Begin the consultation effortlessly",
    },
    {
      image: CarouselImageFour,
      caption: "You’re all set!",
      description:
        "You're all set with 'Doctor On Demand.' Start consulting now and make a difference",
    },
  ];

  console.log(data.length);
  return (
    <div>
      <Modal
        className="modal-overlay onboarding-modal"
        size="lg"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="p-0">
          <button
            type="button"
            className="close close-button position-relative pb-0"
            onClick={handleClose}
          >
            <img src={CloseBtn} alt="modal-close" className="w-30" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Carousel activeIndex={index} onSelect={handleSelect} interval={null}>
            {data.map((slide, i) => {
              return (
                <Carousel.Item>
                  <img
                    className="d-block carousel-item__img"
                    src={slide.image}
                    alt="slider"
                  />
                  <h3 className="carousel-item__title">{slide.caption}</h3>
                  <p className="carousel-item__description">
                    {slide.description}
                  </p>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </Modal.Body>
        <Modal.Footer className="button-footer row">
          <button
            className={"btn btn-link back " + (index > 0 ? "" : "hide")}
            onClick={() => handleSelect(index - 1)}
          >
            <>Back</>
          </button>

          <button
            className={
              "btn btn-link next " + (index !== data.length - 1 ? "" : "hidden")
            }
            onClick={() => handleSelect(index + 1)}
          >
            <>Next</>
          </button>
          <button
            className={
              "btn btn-link get-started " +
              (index === data.length - 1 ? "" : "hidden")
            }
            onClick={() => handleClose()}
          >
            <>Get Started</>
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default OnboardingModal;
